import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import enquire from "enquire.js";
import "./css/index.scss";
import AppRouter from "./router/AppRouter";
import Header from "./components/layout/Header";
import HeaderMobile from "./components/layout/HeaderMobile";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/scrollToTop";
import DialogComponent from "./components/dialog";
import AOS from "aos";
import "./css/homePage.scss";

const App = () => {
  const [data, setData] = useState();
  const [isMobile, setIsMobile] = useState();

  // Function to collect data
  const getApiData = async () => {
    const response = await fetch(`https://wwwyotpostg.wpengine.com/wp-json/yotpo/v1/bfcm-acf`).then((response) =>
      response.json()
    );
    console.log(response);
    setData(response);
  };

  useEffect(() => {
    AOS.init({
      // once: true,
      easing: "new-easing",
      duration: 600,
      mirror: true,
      offset: 100,
    });
    if (typeof window.appData !== "undefined") {
      console.log("window.appData is defined");
      setData(window.appData);
    } else {
      // for development purposes only!
      getApiData();
    }
  }, []);

  const handleAnimation = (color) => {
    let routeAnimation = document.getElementById("routeAnimation");
    routeAnimation.classList.add("animation");
    routeAnimation.style.backgroundColor = color;
    setTimeout(() => {
      routeAnimation.classList.remove("animation");
    }, 1000);
  };

  useEffect(() => {
    enquire.register(`(max-width:767px)`, {
      match: function () {
        setIsMobile(true);
      },
      unmatch: function () {
        setIsMobile(false);
      },
    });
  }, [isMobile]);

  const basename =
    window.isLocalhost || typeof window.isLocalhost === "undefined" ? "/yotpo/bfcm-2" : "/black-friday-marketing";

  return (
    <>
      {data && (
        <BrowserRouter basename={basename}>
          <ScrollToTop />
          {isMobile && <HeaderMobile {...data.header} handlePageRoute={handleAnimation} />}
          {!isMobile && <Header {...data.header} handlePageRoute={handleAnimation} />}
          <AppRouter {...data} />
          <div id="routeAnimation"></div>
          <Footer {...data.footer} />
          {/* <DialogComponent /> */}
        </BrowserRouter>
      )}
    </>
  );
};

export default App;
